var _desc, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbstractAvatar8SquareStreamlineAbstract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 513 513",
    height: 100,
    width: 100,
    strokeWidth: 1,
    id: "Abstract-Avatar-8-Square--Streamline-Abstract.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Abstract Avatar 8 Square Streamline Emoji: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M.694.871h512v512h-512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4583e",
    fillRule: "evenodd",
    d: "M364.761 293.849c11.447-21.359 17.892-45.486 17.892-71.027 0-87.389-75.451-158.2322-168.524-158.2322V207.051c-12.715-20.699-30.363-38.457-52.496-51.331-75.5406-43.938-174.7133-14.336-221.5086 66.118l123.8341 72.027c-24.3524.632-48.6299 7.037-70.90793 19.804C-82.7707 357.12-106.721 457.807-60.4437 538.559L63.497 467.532c-11.4463 21.359-17.8913 45.487-17.8913 71.028 0 87.389 75.4503 158.232 168.5233 158.232V554.33c12.715 20.699 30.364 38.458 52.497 51.331 75.54 43.938 174.713 14.336 221.508-66.118L364.3 467.516c24.352-.631 48.63-7.036 70.908-19.803 75.821-43.451 99.771-144.138 53.494-224.891l-123.941 71.027Zm-150.72 86.479c.029-.052.059-.103.088-.154l0 .154-.088 0Zm.088.726v.154l.089-.154-.089 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 16,
    d: "M196.276 316.59c-9.941 10.665-26.059 10.667-36 .003"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 16,
    d: "M280.276 316.59c-9.941 10.665-26.059 10.667-36 .003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M204.276 382.59a16 24 0 1 0 32 0 16 24 0 1 0-32 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M0 0h512v512H0z",
    transform: "translate(.276 .59)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractAvatar8SquareStreamlineAbstract);
export default __webpack_public_path__ + "static/media/Abstract-Avatar-8-Square--Streamline-Abstract.9f7a5703718a803472d8b2428110e488.svg";
export { ForwardRef as ReactComponent };